import {SVGProps} from 'react';



function Bubble3Icon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1.27em"
            height="1em"
            viewBox="25 0 400 250"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M448.76 175.29c12.22-49.98-25.06-84.13-36.96-151.01-11.9-66.89 14.34-109.1-41.91-146.75-56.25-37.64-187.58-34.85-256.99 27.84-82.54 55.3-76 161.7-51.9 199.06 24.1 37.34 65.3 15.44 131 41.65s90.57 87.16 141.79 87.67c65.32.65 102.76-8.49 114.97-58.46z"
                fill="#E1EBFD"
                fillOpacity={0.34}
            />
            <path
                opacity={0.05}
                d="M388.51 142.48c9.24-35.98-8.47-53.25-16.83-101.25-8.36-48 4.62-84.16-36.44-110.9-41.06-26.75-110-28.23-158.7 3.9-48.68 32.13-75.34 81.69-70.27 133.64 5.08 51.96 42.52 55.7 90.57 74.19 48.06 18.47 77.85 42.83 111.9 46.47 34.04 3.65 70.53-10.06 79.77-46.05z"
                fill="#46A3FD"
            />
        </svg>
    );
}

export default Bubble3Icon;
